<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Create Doctor Appointment</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-doctors' }">Back</router-link>
          </div>
        </div>
      </section>

      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <form @submit.prevent="createAppointmentDoctor">

              <div class="row">

                <!-- Doctor Service Specialty -->
                <div class="form-group col-md-12 mb-2">
                  <label>Select Doctor Service</label>
                  <multiselect
                    v-model="selectedDoctorService"
                    :options="doctorServices"
                    label="label"
                    track-by="id"
                    placeholder="Select Doctor Service"
                    @input="clearError('doctor_service_specialty_id')"
                  />
                  <span v-if="errors.doctor_service_specialty_id" class="error">
                    {{ errors.doctor_service_specialty_id[0] }}
                  </span>
                </div>

                <!-- Day -->
                <div class="form-group col-md-12 mb-2">
                  <label>Day</label>
                  <multiselect
                    v-model="appointmentDay"
                    :options="appointmentDays"
                    label="name"
                    track-by="id"
                    placeholder="Select a Day"
                    @input="clearError('appointment_day_id')"
                  />
                  <span v-if="errors.appointment_day_id" class="error">
                    {{ errors.appointment_day_id[0] }}
                  </span>
                </div>

                <!-- Hour -->
                <div class="form-group col-md-12 mb-2">
                  <label>Hour</label>
                  <multiselect
                    v-model="appointmentHour"
                    :options="multiselectOptions"
                    label="label"
                    track-by="value"
                    placeholder="Select an hour"
                    @input="clearError('appointment_hour_id')"
                  />
                  <span v-if="errors.appointment_hour_id" class="error">
                    {{ errors.appointment_hour_id[0] }}
                  </span>
                </div>

       

                <!-- General Error -->
                <div v-if="errors.general" class="form-group col-md-12 mb-2">
                  <span class="error">{{ errors.general }}</span>
                </div>

              </div>

              <button type="submit" class="btn btn-primary mb-2">Submit</button>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import Multiselect from "vue-multiselect";

export default {
  name: "CreateAppointmentDoctor",
  components: { Multiselect },

  data() {
    return {
      errors: {},

      doctorServices: [],
      selectedDoctorService: null,

      appointmentDays: [],
      appointmentDay: null,

      appointmentHours: [],
      appointmentHour: null,
      multiselectOptions: [],

  
    };
  },

  created() {
    this.fetchDoctorServices();
    this.fetchAppointmentDays();
    this.fetchAppointmentHours();
  },

  methods: {
    clearError(field) {
      if (this.errors[field]) delete this.errors[field];
    },

    validateForm() {
      this.errors = {};

      if (!this.selectedDoctorService) this.errors.doctor_service_specialty_id = ["Doctor Service is required."];
      if (!this.appointmentDay) this.errors.appointment_day_id = ["Day is required."];
      if (!this.appointmentHour) this.errors.appointment_hour_id = ["Hour is required."];
       

      return Object.keys(this.errors).length === 0;
    },
 async fetchDoctorServices() {
  try {
    const doctorId = this.$route.params.doctor_id;

    const res = await axios.get(
      `/admin/admin/appointment-doctor/doctor-specialties/${doctorId}`
    );

    this.doctorServices = res.data.data.map(item => {
      // تحديد اسم المكان (Clinic / Hospital)
      let placeName = '';

      if (item.info_service) {
        placeName = item.info_service.name_en;
      } else if (item.external_clinic_service) {
        placeName = item.external_clinic_service.name_en;
      }

      return {
        ...item,
        label: `${item.speciality?.name_en} (${item.service?.name_en}) - ${placeName}`

      };
    });

  } catch (e) {
    console.error("fetchDoctorServices error", e);
  }
},


    async fetchAppointmentDays() {
      const res = await axios.get("/admin/admin/appointment-day/all");
      this.appointmentDays = res.data.data;
    },

    async fetchAppointmentHours() {
      const res = await axios.get("/admin/admin/appointment-hour/all");
      this.appointmentHours = res.data.data;
      this.multiselectOptions = this.appointmentHours.map(h => ({
        label: `${h.from} - ${h.to}`,
        value: h.id
      }));
    },

    async createAppointmentDoctor() {
      if (!this.validateForm()) return;

      try {
        const formData = new FormData();
        formData.append("doctor_service_specialty_id", this.selectedDoctorService.id);
        formData.append("appointment_day_id", this.appointmentDay.id);
        formData.append("appointment_hour_id", this.appointmentHour.value);
        

        await axios.post("admin/admin/appointment-doctor/create", formData);

        this.$router.push({ name: "all-appointmentDoctors" });

      } catch (error) {
        this.errors = {};
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        } else {
          this.errors.general = "Invalid Input";
        }
      }
    },
  },
};
</script>

<style scoped>
form {
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
}

button {
  width: 100%;
}

.error {
  color: #a94442;
  font-size: 12px;
}
</style>
